<template>
  <div id="app">
    <TopBar v-if="isNone" />
    <keep-alive :exclude="['BookList', 'AdvancedSearch', 'home', 'pdf', 'ebook']">
      <router-view class="root-container" />
    </keep-alive>
    <BottomInfo v-if="isNone" />
  </div>
</template>

<script>
import TopBar from './components/TopBar.vue'
import BottomInfo from 'components/BottomInfo'

export default {
  components: {
    TopBar,
    BottomInfo,
  },
  watch: {
    $route(to) {
      if (
        to.path == '/login' ||
        to.path == '/register' ||
        to.path == '/pdf' ||
        to.path == '/loading' ||
        to.path == '/ebook'
      ) {
        this.isNone = false
      } else {
        this.isNone = true
      }
    },
  },
  data() {
    return {
      isNone: true,
    }
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
#app {
  --main-color: #2f8bd6;
  display: flex;
  flex-direction: column;
}
.root-container {
  min-height: calc(100vh - 406px);
}
</style>
